
$(".logo-slider").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    centerMode: true,
    speed: 5000,
    autoplaySpeed: 0,
    lazyLoad: 'ondemand',
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          speed: 3000,
        },
      },
    ],
  });

$(".top-slider").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<div class="custom-arrow-prev"></div>',
  nextArrow: '<div class="custom-arrow-next"></div>',
  dots: true,
  arrows: true,
  responsive: [
    {
      breakpoint: 799,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
      },
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      },
    },
  ],
});


$(".fs-slider").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  lazyLoad: 'ondemand',
  cssEase: "linear",
  dots: true,
  arrows: true,
  prevArrow: '<div class="fp-custom-arrow-prev"></div>',
  nextArrow: '<div class="fp-custom-arrow-next"></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        
      },
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        
      },
    },
  ],
});

// function reviewSlider() {
//   console.log('Reveiw slider running')
// }

// $(".button--via-style").on("click", function () {
//   $("#lm-video").css("z-index", "50000");
//   $(".lm-hand-wrapper").css("z-index", "-50000");
// });



document
  .querySelectorAll(".button--add-to-cart.add_to_cart")
  // .querySelectorAll(".button--add-to-cart.add_to_cart:not(.button--add-to-cart.add_to_cart.no-image)")
  .forEach((button) => {
    var valueText = button.disabled;
    var flower = `<img src="https://www.viacitrus.com/cdn/shop/t/35/assets/lemons.png?v=128067643185223438821685477266" width="43" height="31" alt="Add to cart icon" loading="lazy">`
    button.innerHTML = `
    ${button.classList.contains('no-image') ? '' : flower}
    <span class="text">${valueText ? "Sold out" : "Add to cart"}</span>
    <svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark">
            <path fill="none" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"/>
          </svg>
    `;
    // console.log('added success')
  });



  